import { motion } from "framer-motion";
import {
  Monitor,
  Target,
  Instagram,
  MessageCircle,
  CalendarDays,
  ShoppingBag,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: Monitor,
    title: "Web Sitesi Tasarımı",
    desc: "Modern, hızlı ve mobil uyumlu, dönüşüm odaklı kurumsal web siteleri.",
    points: ["SEO altyapısı", "Hız optimizasyonu", "Mobil öncelikli"],
    tone: "blue",
  },
  {
    icon: Target,
    title: "Google Reklam Yönetimi",
    desc: "Doğru kitleye doğru bütçeyle ulaşarak satışlarınızı maksimize edin.",
    points: ["Arama & Display", "Performans Max", "Aylık raporlama"],
    tone: "navy",
  },
  {
    icon: Instagram,
    title: "Instagram Reklam Yönetimi",
    desc: "Görsel gücünüzü kullanarak sosyal medyada marka bilinirliğinizi artırın.",
    points: ["Reels stratejisi", "Hedef kitle analizi", "Yaratıcı içerik"],
    tone: "blue",
  },
  {
    icon: MessageCircle,
    title: "WhatsApp İşletme Yönetimi",
    desc: "Müşteri iletişimini profesyonelleştiren WhatsApp Business entegrasyonları.",
    points: ["Otomatik mesaj", "Katalog", "Toplu yanıt"],
    tone: "green",
  },
  {
    icon: CalendarDays,
    title: "Randevu Yönetim Sistemi",
    desc: "Hizmet sektörüne özel, 7/24 otomatik randevu alabileceğiniz altyapılar.",
    points: ["Online takvim", "Hatırlatma", "Müşteri paneli"],
    tone: "violet",
  },
  {
    icon: ShoppingBag,
    title: "Sipariş Takip Sistemi",
    desc: "E-ticaret ve yerel işletmeler için kolay yönetilebilir sipariş panelleri.",
    points: ["Canlı durum", "Kurye entegrasyonu", "Raporlama"],
    tone: "navy",
  },
];

const toneStyles = {
  blue: "bg-[var(--ab-blue)] text-white",
  navy: "bg-[var(--ab-navy)] text-white",
  violet: "bg-[var(--ab-violet)] text-white",
  green: "bg-[var(--wa-green)] text-white",
};

export default function Services() {
  return (
    <section
      id="hizmetler"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-[var(--ab-bg-soft)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="ab-chip" data-testid="services-chip">
            Hizmetlerimiz
          </span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
            Markanızı büyütecek <span className="ab-text-gradient">dijital çözümler</span>.
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">
            Tasarımdan reklama, otomasyondan operasyona kadar işletmenizin
            dijital ihtiyaçlarını tek bir ekipten alın.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                data-testid={`service-card-${i}`}
                className="ab-card group p-7 relative overflow-hidden"
              >
                <div className="flex items-start justify-between">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center ${toneStyles[s.tone]}`}
                  >
                    <Icon className="h-6 w-6" strokeWidth={2.2} />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-[var(--ab-blue)] group-hover:rotate-12 transition-all" />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold text-[var(--ab-navy)]">
                  {s.title}
                </h3>
                <p className="mt-2 text-slate-600 leading-relaxed text-[0.95rem]">
                  {s.desc}
                </p>
                <ul className="mt-5 space-y-1.5">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-2 text-sm text-slate-500"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-[var(--ab-blue)]" />
                      {p}
                    </li>
                  ))}
                </ul>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
